export default "__VITE_ASSET__DFGclFJN__"